import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

// Theme colors from design system
export const themeColors = {
  body: '#063142', // Body color - dark navy
  white: '#FFFFFF',
  blue: '#00ACE7', // Theme Primary Blue
  midGrey: '#9CADB4', // Mid 2 color
};

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  disabled?: boolean;
  isAdminDisabled?: boolean;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({ checked, onChange, label, disabled, isAdminDisabled }) => {
  return (
    <Box 
      data-testid={`checkbox-container-${label.toLowerCase().replace(/\s+/g, '-')}`}
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2, 
        mb: 1.5,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.7 : 1,
        '&:hover': {
          '& .checkbox-box': {
            borderColor: disabled ? '#ccc' : themeColors.blue,
          }
        }
      }}>
      <Box 
        data-testid={`checkbox-box-${label.toLowerCase().replace(/\s+/g, '-')}`}
        className="checkbox-box"
        sx={{ 
          width: 16, 
          height: 16, 
          borderRadius: 1, 
          backgroundColor: checked ? (disabled ? themeColors.midGrey : themeColors.blue) : 'transparent',
          border: `1px solid ${checked ? (disabled ? themeColors.midGrey : themeColors.blue) : '#ccc'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s',
        }}
        onClick={() => {
          if (disabled) return;
          const fakeEvent = {
            target: { checked: !checked }
          } as React.ChangeEvent<HTMLInputElement>;
          onChange(fakeEvent);
        }}
      >
        {checked && <CheckIcon sx={{ color: themeColors.white, fontSize: 14 }} />}
      </Box>
      <Box 
        data-testid={`checkbox-label-container-${label.toLowerCase().replace(/\s+/g, '-')}`}
        sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography sx={{ 
          fontSize: 14, 
          color: disabled ? themeColors.midGrey : themeColors.body,
          fontFamily: '"Lato-Regular", sans-serif',
        }}>
          {label}
        </Typography>
        {isAdminDisabled && (
          <Typography
            component="span"
            sx={{
              fontSize: 11,
              color: '#d32f2f',
              ml: 1,
              backgroundColor: 'rgba(211, 47, 47, 0.05)',
              padding: '0px 4px',
              borderRadius: '2px',
            }}
          >
            Admin restricted
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CustomCheckbox; 